import { render } from "./portfolioAccess.vue?vue&type=template&id=22ebff86&scoped=true"
import script from "./portfolioAccess.vue?vue&type=script&lang=js"
export * from "./portfolioAccess.vue?vue&type=script&lang=js"

import "./portfolioAccess.vue?vue&type=style&index=0&id=22ebff86&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ebff86"]])

export default __exports__